
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"-36 -24 72 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M-36-24h72v48h-72z"}}),_c('g',{attrs:{"transform":"rotate(-56.31)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M-6-25H6m-12 3H6m-12 3H6","stroke":"#000","stroke-width":"2"}}),_c('use',{attrs:{"xlink:href":"#a","y":"44"}})]),_c('path',{attrs:{"stroke":"#fff","d":"M0 17v10"}}),_c('circle',{attrs:{"fill":"#c60c30","r":"12"}}),_c('path',{attrs:{"fill":"#003478","d":"M0-12A6 6 0 000 0a6 6 0 010 12 12 12 0 010-24z"}})]),_c('g',{attrs:{"transform":"rotate(-123.69)"}},[_c('use',{attrs:{"xlink:href":"#b"}}),_c('path',{attrs:{"stroke":"#fff","d":"M0-23.5v3M0 17v3.5m0 3v3"}})])])
          )
        }
      }
    